import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListHerdLots from './ListHerdLots.js';
import AddHerdLot from './AddHerdLot.js';
import WhatsAppTip from '../../shared/WhatsAppTip.js';
import { herdLotTips } from '../../shared/whatsappTips.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

export const HerdLotsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton isActive={screen === 'list'} onClick={() => setScreen('list')} />
    <AddButton  isActive={screen === 'add'}  onClick={() => setScreen('add')} />
  </div>
);

const formatCode = (lotId, prefix) =>
  lotId != null ? `${prefix}-${String(lotId).padStart(4, '0')}` : '';

export const HerdLots = ({ screen, setScreen, actions }) => {
  const { t } = useTranslation();
  const [localScreen, setLocalScreen] = useState('list');
  const [listKey,     setListKey]     = useState(0);
  const [tip,         setTip]         = useState(null);

  const currentScreen    = screen    !== undefined ? screen    : localScreen;
  const setCurrentScreen = setScreen !== undefined ? setScreen : setLocalScreen;

  const handleCreated = (lot) => {
    setCurrentScreen('list');
    setListKey(k => k + 1);
    const code = formatCode(lot?.lot_id, t('herd_lot_prefix'));
    if (code) {
      setTip({
        title: `✅ ${code} ${t('created')}`,
        tips: herdLotTips(code, t),
      });
    }
  };

  return (
    <>
      {actions && <div className="content-header">{actions}</div>}
      {currentScreen === 'list' && (
        <>
          {tip && (
            <WhatsAppTip
              title={tip.title}
              tips={tip.tips}
              onDismiss={() => setTip(null)}
            />
          )}
          <ListHerdLots refreshKey={listKey} />
          <FAB onClick={() => setCurrentScreen('add')} />
        </>
      )}
      {currentScreen === 'add' && (
        <AddHerdLot onSuccess={handleCreated} />
      )}
    </>
  );
};

export default HerdLots;
